import React from 'react'
import history from './../../history'
import { setHtmlStorage, statusHtmlStorage } from './../../services/helper'
import { requestForToken } from './../../services/firebase'


class LoginController extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      alertShow: false,
      alertVariant: 'danger',
      alertMessage: '',
      email: '',
      password: '',
      passSuccess: false,
      adminID: '',
      otp: '',
    }
  }

  componentDidMount() {
    if (statusHtmlStorage('accessToken') === 1) {
      history.push('/dashboard')
    }
  }

  loginOtp = async evt => {
    evt.preventDefault()

    const payload = {
      admin_id: this.state.adminID,
      // otp: this.state.otp
      otp: '123',
      fcm_token: await requestForToken()
    }

    await this.props.loginOtp(payload)

    if ([200, 201].includes(this.props.otpResponse.meta.code)) {
      const d = new Date(this.props.otpResponse.data.expiry_time)
      const ms = d.getUTCMilliseconds()
      setHtmlStorage('accessToken', this.props.otpResponse.data.access_token, ms)
      setTimeout(() => {
        window.location = '/dashboard'
      }, 1000)
    } else {
      this.setState({
        alertShow: true,
        alertVariant: 'danger',
        alertMessage: this.props.otpResponse.meta.message
      })
    }
  }

  loginPassword = async evt => {
    evt.preventDefault()

    const payload = {
      email: this.state.email,
      password: this.state.password
    }

    await this.props.loginPassword(payload)

    if ([200, 201].includes(this.props.passResponse.meta.code)) {
      this.setState({
        passSuccess: true,
        adminID: this.props.passResponse.data.id
      })
    } else {
      this.setState({
        alertShow: true,
        alertVariant: 'danger',
        alertMessage: this.props.passResponse.meta.message
      })
    }
  }

  handleInputChange = evt => {
    const { name, value } = evt.target
    this.setState({ [name]: value })
  }

  handleAlertClose = () => {
    this.setState({
      alertShow: false,
      alertVariant: 'danger',
      alertMessage: ''
    })
  }
}

export default LoginController